<h1 class="raportti-header">Tase</h1>

@if (taseEnsin) {
  <div class="tulos-ensin">
    <app-button (click)="tulosEnsinClicked.emit()" actionId="Tulos ensin (näkymä)" additionalClass="report-btn tulos-ensin-button">
      <div>Tulos ensin</div>
    </app-button>
  </div>
}

@if (tuloslaskelmanDataObservable | async; as data) {
  @if (!lataa()) {
    @if (data.e == 'a') {
      <div>Valittu päivämäärä ei ole millään Lemonatorista löytyvällä tilikaudella.</div>
    }
    @if (lastSucessfullyUpdated()) {
      <div class="gray-text" style="font-size: 11px; text-align: left; margin-left: 5px; margin-top: 16px; line-height: 13px">Päivitetty {{ lastSucessfullyUpdated() | ltimestamptime | async }}</div>
    }
    @if (data.c == 'c2') {
      <table class="report-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ data.c1Header }}</th>
            <th>{{ data.c2Header }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of data.data; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr class="report-row-lvl-{{ row.l }}" [class.report-row-summary]="row.s" [class.report-row-summary-vs]="row.vs">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | number: '1.2-2' }}</td>
              <td>{{ row.s2 | number: '1.2-2' }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
    @if (data.c == 'c1') {
      <table class="report-table">
        <thead>
          <tr>
            <th></th>
            <th>{{ data.c1Header }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of data.data; track trackAccountRowByAccountNumberFn($index, row)) {
            <tr class="report-row-lvl-{{ row.l }}" [class.report-row-summary]="row.s" [class.report-row-summary-vs]="row.vs">
              <td class="n">{{ row.n }}</td>
              <td>{{ row.s1 | number: '1.2-2' }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}
